$('[data-read-more-height]').each(function () {
    let $wrapper = $(this).closest('.read-more'),
        height = parseInt($(this).attr('data-read-more-height')) || viewport().height/2,
        $container = $(this);

    if ($container.height() > height) {
        $container.css('height', height+'px');
    } else {
        $wrapper.find('.read-more__toggle-container').remove();
    }
});

$('body').on('click', '.read-more__toggle', function () {
    let $wrapper = $(this).closest('.read-more'),
        $content = $wrapper.find('.read-more__container');

    if ($wrapper.attr('data-state') === 'toggled') {
        $wrapper.attr('data-state', '');
    } else {
        $wrapper.attr('data-state', 'toggled');
    }

    $(this).blur();
});
